import { render, staticRenderFns } from "./AccessButton.vue?vue&type=template&id=613f4a7f&scoped=true"
import script from "./AccessButton.vue?vue&type=script&lang=js"
export * from "./AccessButton.vue?vue&type=script&lang=js"
import style0 from "./AccessButton.vue?vue&type=style&index=0&id=613f4a7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613f4a7f",
  null
  
)

export default component.exports